import _ from 'lodash';

/**
 * This service constructs an object consisting of a property for each location event type (gps, padlock,
 * earthquake) that equals an object with properties 'markerLabel' and 'labelClass.' It is injected and used
 * wherever there is a need to use this dynamic list.
 *
 * @param {object} LocationEventConst the config object for all location events used by the equipment map panel
 */

/* @ngInject */
export default function EventMarkerService(LocationEventConst) {
  const service = this;

  const config = LocationEventConst;

  service.getConfig = () => config;
  service.getMarkerConfig = eventName => config[eventName];

  /**
   * accepts an array of suffix strings and an initialMemo object, loops over the suffixes to combine them with each
   * key string.
   *
   * @param {Array} suffixes a list of suffixes that will each be concatenated to the end of the keys and used as
   * a property name referencing an array
   * @param {object} initialMemo the memo object supplied to the reduce method
   * @returns {object} the initialMemo with all `${key}${suffix}` combinations assigned
   */
  service.initializeStore = (suffixes, initialMemo) => _.reduce(
    config,
    (memo, __, name) => _.assign(memo, ..._.map(suffixes, suffix => ({ [`${name}${suffix}`]: [] }))),
    initialMemo
  );

  /**
   * creates an object of key/value pairs consisting of the event names and true, respectively
   *
   * @returns {object} all event keys set to true
   */
  service.initializeCheckboxes = () =>
    _.transform(config, (memo, __, key) => _.assign(memo, { [key]: true }));

  /**
   * constructs the html of checkboxes for each event name, optionally limited to the
   * equipment types present on the panel (the prefix before '/' in each event name).
   *
   * @param {Array} [equipmentTypes] equipment types on the panel; when provided, only
   * checkboxes for those types are rendered. When omitted, all configured types render.
   * @returns {string} checkbox html
   */
  service.constructMarkerCheckboxes = equipmentTypes => _.reduce(config, (memo, event, name) => {
    const [equipmentType] = name.split('/');
    const isForPanelEquipment = !equipmentTypes || _.includes(equipmentTypes, equipmentType);
    if (isForPanelEquipment && !_.includes(name, '911') && !event.disable) {
      return `${memo}<div class="map-marker-selectable-container"
              draggable="false"
              title="Show ${event.markerLabel} markers"
              ng-click="$event.stopPropagation(); toggleCheckbox('${name}')"
        >
          <span class="map-marker-checkbox-container" role="checkbox">
            <div class="map-marker-checkmark-container" ng-show="markerCheckboxes['${name}']">
              <img class="map-marker-checkmark-img"
                    alt=""
                    src="https://maps.gstatic.com/mapfiles/mv/imgs8.png"
                    draggable="false"
              >
            </div>
          </span>
          <label class="map-marker-label">${event.markerLabel}</label>
        </div>`;
    }
    return memo;
  }, '');
}
